import { isObjectType } from 'customer-data-objects/types/ObjectType';
import { useAccessLevel } from 'customer-data-properties/accessLevel/AccessLevelContext';
import { HIDDEN } from 'customer-data-objects/property/AccessLevel';
import SkeletonView from 'conversations-skeleton-state/components/SkeletonView';
import { jsx as _jsx } from "react/jsx-runtime";
const withRestrictedProperties = /* eslint-disable-next-line react/display-name */
Component => props => {
  const {
    objectType,
    option = {},
    property = {}
  } = props;
  const accessLevel = useAccessLevel({
    objectType,
    propertyName: option.value || property.value || ''
  });
  if (isObjectType(objectType) && accessLevel === null) {
    return /*#__PURE__*/_jsx(SkeletonView, {
      blockSize: "32px",
      inlineSize: "100%"
    });
  }
  return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
    isRestricted: accessLevel === HIDDEN
  }));
};
export default withRestrictedProperties;